import { useState, useEffect } from "react";
import {devSkills} from '../../constants/skills';
import {Skill} from '.';

const Skills = () => {

    const [dotnet, setDotnet] = useState(0);
    const [html, setHtml] = useState(0);
    const [css, setCss] = useState(0);
    const [sql, setSql] = useState(0);
    const [csharp, setCsharp] = useState(0);
    const [js, setJs] = useState(0);
    const [angular, setAngular] = useState(0);
   

    useEffect(() => {
        const timer = setInterval(() => {

            setDotnet((oldProgress) => {
                const diff = Math.random() * 10;
                return Math.min(oldProgress + diff, 30);
            });

            setHtml((oldProgress) => {
                const diff = Math.random() * 10;
                return Math.min(oldProgress + diff, 80);
            });

            setCss((oldProgress) => {
                const diff = Math.random() * 10;
                return Math.min(oldProgress + diff, 65);
            });

            setSql((oldProgress) => {
                const diff = Math.random() * 10;
                return Math.min(oldProgress + diff, 30);
            });
            
            setCsharp((oldProgress) => {
                const diff = Math.random() * 10;
                return Math.min(oldProgress + diff, 30);
            });

            setJs((oldProgress) => {
                const diff = Math.random() * 10;
                return Math.min(oldProgress + diff, 45);
            });

            setAngular((oldProgress) => {
                const diff = Math.random() * 10;
                return Math.min(oldProgress + diff, 30);
            });


        }, 200);

        return () => {
            clearInterval(timer);
        };
    }, []);

    const { dotnetSkill, htmlSkill, cssSkill, jsSkill, sqlSkill, csharpSkill, angularSkill} = devSkills; 

    return (
        <> 
                        <Skill
                            name={csharpSkill.name}
                            icon={csharpSkill.icon}
                            color={csharpSkill.color}
                            value={csharp}
                        />
                        <Skill
                            name={dotnetSkill.name}
                            icon={dotnetSkill.icon}
                            color={dotnetSkill.color}
                            value={dotnet}
                        />
                        <Skill
                            name={sqlSkill.name}
                            icon={sqlSkill.icon}
                            color={sqlSkill.color}
                            value={sql}
                        />
                          <Skill
                            name={angularSkill.name}
                            icon={angularSkill.icon}
                            color={angularSkill.color}
                            value={angular}
                        />
                         <Skill
                            name={jsSkill.name}
                            icon={jsSkill.icon}
                            color={jsSkill.color}
                            value={js}
                        />
                        <Skill
                            name={htmlSkill.name}
                            icon={htmlSkill.icon}
                            color={htmlSkill.color}
                            value={html}
                        />
                        <Skill
                            name={cssSkill.name}
                            icon={cssSkill.icon}
                            color={cssSkill.color}
                            value={css}
                        />
                        </>
    )
};

export default Skills;